import { render } from "./social-share-box.vue?vue&type=template&id=9e5ba00e"
import script from "./social-share-box.vue?vue&type=script&lang=js"
export * from "./social-share-box.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__